import React from 'react';
import { generateTimeSlots } from './utils/timeUtils';

const MeetingForm = ({
  title,
  setTitle,
  selectedDate,
  setSelectedDate,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  meetingType,
  setMeetingType,
  location,
  setLocation,
  notes,
  setNotes,
  error,
  isSubmitting,
  onSubmit,
  onClose
}) => {
  const timeSlots = generateTimeSlots();

  const handleStartTimeChange = (e) => {
    const newStartTime = e.target.value;
    setStartTime(newStartTime);
    
    const startIndex = timeSlots.indexOf(newStartTime);
    if (startIndex >= 0 && startIndex + 2 < timeSlots.length) {
      setEndTime(timeSlots[startIndex + 2]);
    }
  };

  return (
    <form onSubmit={onSubmit} className="p-6">
      <div className="mb-4">
        <label htmlFor="title" className="block mb-1.5 font-medium text-gray-700 text-sm">Meeting Title</label>
        <input
          type="text"
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm text-gray-900 bg-white focus:outline-none focus:border-secondary focus:ring-2 focus:ring-secondary/20"
        />
      </div>

      <div className="flex gap-4 mb-4">
        <div className="flex-1">
          <label htmlFor="date" className="block mb-1.5 font-medium text-gray-700 text-sm">Date</label>
          <input
            type="date"
            id="date"
            value={selectedDate.toISOString().split('T')[0]}
            onChange={(e) => setSelectedDate(new Date(e.target.value))}
            min={new Date().toISOString().split('T')[0]}
            required
            className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm text-gray-900 bg-white focus:outline-none focus:border-secondary focus:ring-2 focus:ring-secondary/20"
          />
        </div>

        <div className="flex-1">
          <label htmlFor="meetingType" className="block mb-1.5 font-medium text-gray-700 text-sm">Meeting Type</label>
          <select
            id="meetingType"
            value={meetingType}
            onChange={(e) => setMeetingType(e.target.value)}
            required
            className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm text-gray-900 bg-white focus:outline-none focus:border-secondary focus:ring-2 focus:ring-secondary/20"
          >
            <option value="video">Video Call</option>
            <option value="phone">Phone Call</option>
            <option value="in-person">In-Person</option>
          </select>
        </div>
      </div>

      <div className="flex gap-4 mb-4">
        <div className="flex-1">
          <label htmlFor="startTime" className="block mb-1.5 font-medium text-gray-700 text-sm">Start Time</label>
          <select
            id="startTime"
            value={startTime}
            onChange={handleStartTimeChange}
            required
            className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm text-gray-900 bg-white focus:outline-none focus:border-secondary focus:ring-2 focus:ring-secondary/20"
          >
            {timeSlots.map((time) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
          </select>
        </div>

        <div className="flex-1">
          <label htmlFor="endTime" className="block mb-1.5 font-medium text-gray-700 text-sm">End Time</label>
          <select
            id="endTime"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            required
            className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm text-gray-900 bg-white focus:outline-none focus:border-secondary focus:ring-2 focus:ring-secondary/20"
          >
            {timeSlots.map((time) => (
              <option
                key={time}
                value={time}
                disabled={time <= startTime}
              >
                {time}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mb-4">
        <label htmlFor="location" className="block mb-1.5 font-medium text-gray-700 text-sm">Location</label>
        <input
          type="text"
          id="location"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder={meetingType === 'in-person' ? 'Address' : meetingType === 'video' ? 'Zoom/Teams Link' : 'Phone Number'}
          required
          className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm text-gray-900 bg-white focus:outline-none focus:border-secondary focus:ring-2 focus:ring-secondary/20"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="notes" className="block mb-1.5 font-medium text-gray-700 text-sm">Notes (Optional)</label>
        <textarea
          id="notes"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          rows="3"
          placeholder="Add any additional information about this meeting"
          className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm text-gray-900 bg-white focus:outline-none focus:border-secondary focus:ring-2 focus:ring-secondary/20 resize-y"
        />
      </div>

      {error && (
        <div className="text-error bg-red-100 p-3 rounded-md mt-4 text-sm">
          {error}
        </div>
      )}

      <div className="flex justify-end gap-3 mt-6">
        <button
          type="button"
          className="px-4 py-2.5 bg-white border border-gray-300 rounded-md font-medium text-sm text-gray-700 hover:bg-gray-100 transition-colors"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          type="submit"
          className={`px-4 py-2.5 rounded-md font-medium text-sm text-white transition-colors ${
            isSubmitting
              ? 'bg-secondaryLight border-secondaryLight cursor-not-allowed'
              : 'bg-secondary border-secondary hover:bg-secondaryDark'
          }`}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Scheduling...' : 'Schedule Meeting'}
        </button>
      </div>
    </form>
  );
};

export default MeetingForm;